module.exports = __webpack_public_path__ + "img/classic_rental40_2.19124721.jpg";